<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} CUSTOMER</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

        <div class="p-6">
            
            <vx-card class="attachments mb-4" v-if="checkFlag(pictures)">
                <div style="position:relative;">
                    <vs-button radius color="danger" style="position:absolute; top:0" @click="delete_image()" v-if="permissions_update || permissions_create" icon-pack="feather" icon="icon-trash-2"></vs-button>
                    <img alt="Cus Image" title="Cus Image" style="height: auto; width:50%; cursor:pointer" :src="checkImageUrl(pictures)">
                </div>
            </vx-card>
            
            <vue-dropzone v-else class="mb-4" style="height: 100px; width:100%;" id="dropzone" ref="myVueDropzone2" :use-custom-slot="true" :options="dropzoneOptions" @vdropzone-sending="sendingEvent" @vdropzone-complete="afterComplete">
                <div class="dropzone-custom-content">
                    <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                    <h4>Drop files here or click to upload.</h4>
                </div>
            </vue-dropzone>
            <!-- GROUP ID -->
            <vs-select autocomplete v-if="user_info.role == 'SUPERADMIN' || user_info.role == 'DEVELOPER' " v-model="groupid" label="Group/群" class="w-full mb-2">
                <vs-select-item :key="index" :value="item.groupid" :text="item.name" v-for="(item,index) in groupid_list" />
            </vs-select>

            <!-- NAME -->
            <vs-input label="Name/名字*" v-model="name" class="w-full mt-5" name="name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

            <!-- ID NO -->
            <vs-input label="IC/身份证*" v-model="idno" class="w-full mt-5" name="identity_no" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('identity_no')">{{ errors.first('identity_no') }}</span>

            <!-- CONTACT -->
            <vs-input label="Contact No/电话号码*" v-model="contact" class="w-full mt-5" name="contact" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('contact')">{{ errors.first('contact') }}</span>
            <br>
            <vs-radio v-model="radios1" class="mt-5" vs-value="input">Input</vs-radio>
            <vs-radio v-model="radios1" class="ml-5 mt-5" vs-value="123">Datepicker</vs-radio>

            <datepicker v-if="radios1 == 123" placeholder="D.O.B/生日日期" v-model="myDate" format="yyyy-MM-dd" @input="dob = fixDate($event)"></datepicker>
            <vs-input v-else label="D.O.B/生日日期: YYYY-MM-DD" placeholder="Eg. 2022-03-01" v-model="dob" class="w-full" />

            <vs-input label="Occupation/工作" v-model="career" class="w-full mt-5" />

            <vs-textarea label="Address/地址" v-model="address" class="mt-5 w-full" height="130px" />

            <!-- Remark -->
            <vs-textarea label="Remark/备注" v-model="remark" class="mt-5 w-full" height="130px" />

            <!-- STATUS -->
            <vs-select autocomplete v-model="status" label="Status/状态" class="w-1/2 mb-2">
                <vs-select-item key="1" value="ACTIVE" text="ACTIVE" />
                <vs-select-item key="2" value="INACTIVE" text="INACTIVE" />
            </vs-select>

            <vs-divider class="mt-5 mb-5"></vs-divider>

            <!-- <vs-button size="small" color="warning" type="border" v-show="!flag_edit" @click="toggle">Edit</vs-button>
        <vs-button size="small" color="warning" type="border" v-show="flag_edit" @click="cancelEdit">Cancel</vs-button> -->

            <vs-table stripe :data="contact_lists" class="mt-2" v-show="largeScreenWidth">

                <template slot="thead">
                    <vs-th width="25%">Name</vs-th>
                    <vs-th width="20%">Contact</vs-th>
                    <vs-th width="25%">Address</vs-th>
                    <vs-th width="20%">Remark</vs-th>
                    <vs-th width="10%">
                        <vs-button color="primary" type="filled" icon="add" @click="new_contact"></vs-button>
                    </vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].name">
                            <vs-textarea placeholder="Name" v-model="data[indextr].name" class="w-full" width="125px" height="120px" />
                            <!-- <span v-else>{{ data[indextr].name }}</span> -->
                        </vs-td>

                        <vs-td :data="data[indextr].contact_no">
                            <!-- <span v-if="!flag_edit"><a :href="'tel:'+data[indextr].contact_no">{{ data[indextr].contact_no }}</a></span> -->
                            <vs-textarea placeholder="Contact" v-model="data[indextr].contact_no" class="w-full" width="95px" height="120px" />
                        </vs-td>

                        <vs-td :data="data[indextr].address">
                            <!-- <span v-if="!flag_edit">{{ data[indextr].address }}</span> -->
                            <vs-textarea placeholder="Address" v-model="data[indextr].address" class="w-full" width="125px" height="120px" />
                        </vs-td>

                        <vs-td :data="data[indextr].remark">
                            <!-- <span v-if="!flag_edit">{{ data[indextr].remark }}</span> -->
                            <vs-textarea placeholder="Remark" v-model="data[indextr].remark" class="w-full" width="95px" height="120px" />
                            <!-- <vs-input placeholder="Remark" v-model="data[indextr].remark" class="w-full" /> -->
                        </vs-td>

                        <vs-td :data="data[indextr].name">
                            <vs-button color="danger" type="border" icon="remove" @click="remove_this(index)"></vs-button>
                        </vs-td>
                    </vs-tr>
                </template>

            </vs-table>

            <div v-show="!largeScreenWidth">
                <div class="mt-6 flex items-center justify-between px-6">
                    <h6>Dependent List</h6>
                    <feather-icon icon="PlusIcon" @click="new_contact" class="cursor-pointer text-primary"></feather-icon>
                </div>
                <!-- <vs-button color="primary" type="filled" icon="add"></vs-button> -->
                <div class="w-full" v-for="(item,index) in contact_lists">
                    <vx-card :title="'Contact '+(index+1)" class="mb-3 mt-3">
                        <template slot="actions">
                            <feather-icon icon="TrashIcon" svgClasses="stroke-current text-danger w-4 h-4" class="ml-1" @click="remove_this(index)" />
                            <!-- <vs-button size="small" color="primary" type="border" @click="gotoCustomer(item.uuid)">View</vs-button> -->
                        </template>

                        <vs-input label="Name" v-model="item.name" class="w-full mb-2" />
                        <vs-input label="Contact" v-model="item.contact_no" class="w-full mb-2" />
                        <vs-input label="Address" v-model="item.address" class="w-full mb-2" />
                        <vs-input label="Remark" v-model="item.remark" class="w-full" />
                    </vx-card>

                </div>
            </div>

            <!-- <a v-show="uuid !== '' " class="text-sm" href="javascript:void(0)" style="text-decoration:underline" @click="popupActive=true">View Dependent</a>

        <vs-popup fullscreen title="Customer Dependent List" :active.sync="popupActive">
          <contact :customerId="uuid" v-if="isSidebarActive" />
        </vs-popup> -->

        </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid" v-show="permissions_create || permissions_update">{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }}</vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
</vs-sidebar>
</template>

<script>
// import Contact from './contact.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Datepicker from 'vuejs-datepicker';
import moment from 'moment'
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import imageCompressor from 'vue-image-compressor'
import imageCompression from 'browser-image-compression'
import {
    imageCompression_options
} from '../../main'

import moduleCustomerManagement from '@/store/customer-management/moduleCustomerManagement.js'
export default {
    props: {
        isSidebarActive: {
            type: Boolean,
            required: true
        },
        data: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        VuePerfectScrollbar,
        Datepicker,
        vueDropzone: vue2Dropzone,
        imageCompressor
        // Contact
    },
    data() {
        return {
            dropzoneOptions: {
                // url: "https://httpbin.org/post",
                url: process.env.VUE_APP_GLOBALURL + '/customer/pictures',
                thumbnailWidth: 100,
                thumbnailHeight: 100,
                maxThumbnailFilesize: 1,
                maxFilesize: 2,
                maxFiles: 1,
                parallelUploads: 1,
                autoDiscover: false,
                uploadMultiple: true,
                autoProcessQueue: true,
                // autoProcessQueue: true,
                acceptedFiles: ".jpeg,.jpg,.png,.gif",
                // forceFallback: true,
                headers: {
                    'Cache-Control': null,
                    'X-Requested-With': null,
                    Authorization: "Bearer " + sessionStorage.getItem('accessToken')
                },
                addRemoveLinks: true
            },
            contact_lists: [],
            backup_contact_list: [],
            flag_edit: false,

            popupActive: false,
            myDate: '',

            uuid: '',
            name: '',
            idno: '',
            contact: '',
            dob: '',
            career: '',
            address: '',
            remark: '',
            pictures: '',
            ori_pictures: '',

            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60
            },
            groupid: '',
            status: 'ACTIVE',
            radios1: 'input'
        }
    },
    watch: {
        radios1(val) {
            if (val) {
                this.dob = ''
            }
        },
        uuid() {
            // console.log('watch customer id', this.uuid)
            this.loadCustomerInfo(this.uuid)
        },
        // isSidebarActive (val) {
        //   console.log('val',val)
        //   if (!val) return
        //   if (Object.entries(this.data).length === 0) {
        //     console.log('val222')
        //     this.initValues()
        //     this.$validator.reset()
        //   } else {

        //     let data = JSON.parse(JSON.stringify(this.data))
        //     console.log('data',data)
        //     this.uuid = data.uuid
        //     this.name = data.name
        //     this.idno = data.idno
        //     this.contact = data.contact
        //     this.dob = (data.dob == '' || data.dob == 'undefined') ? '' : data.dob
        //     this.myDate = (data.dob == '' || data.dob == 'undefined') ? '' : new Date(data.dob)
        //     this.career = data.career == 'UNDEFINED' ? '' : data.career
        //     this.address = data.address == 'UNDEFINED' ? '' : data.address
        //     this.remark = data.remark

        //     this.initValues()
        //   }
        // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
        // }
    },
    computed: {
        isSidebarActiveLocal: {
            get() {
                return this.isSidebarActive
            },
            set(val) {
                if (!val) {
                    this.$emit('closeSidebar')
                    // this.$validator.reset()
                    // this.initValues()
                }
            }
        },
        isFormValid() {
            return !this.errors.any() && this.groupid && this.name && this.idno && this.contact
        },
        scrollbarTag() {
            return this.$store.getters.scrollbarTag
        },
        groupid_list() {
            let temp = []

            this.users.forEach(function (item) {
                if (item.role !== 'WORKER') {
                    temp.push({
                        groupid: item.groupid ? item.groupid : item.role == 'DEVELOPER' ? 'dev' : item.role == 'SUPERADMIN' ? 'superadmin' : '',
                        name: item.name
                    })
                }
            })

            return temp
        },
        user_info() {
            let data = JSON.parse(sessionStorage.getItem('userInfo'));
            return data
        },
        users() {
            return this.$store.state.userManagement.users
        },
        largeScreenWidth() {
            if (window.innerWidth > 575) {
                return true
            } else
                return false
        },
        permissions() {
            if (this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.permissions) {
                return this.$store.state.AppActiveUser.permissions;
            } else {
                return []
            }
        },
        permissions_create() {
            if (this.permissions.includes('*') || this.permissions.includes('021')) {
                return true
            } else {
                return false
            }
        },
        permissions_list() {
            if (this.permissions.includes('*') || this.permissions.includes('022')) {
                return true
            } else {
                return false
            }
        },
        permissions_update() {
            if (this.permissions.includes('*') || this.permissions.includes('023')) {
                return true
            } else {
                return false
            }
        },
        permissions_delete() {
            if (this.permissions.includes('*') || this.permissions.includes('024')) {
                return true
            } else {
                return false
            }
        },
    },
    created() {
        if (!moduleCustomerManagement.isRegistered) {
            this.$store.registerModule('customerManagement', moduleCustomerManagement)
            moduleCustomerManagement.isRegistered = true
        }

        if (!this.isSidebarActiveLocal) return
        if (Object.entries(this.data).length === 0) {
            console.log('empty value')
            this.initValues()
            this.$validator.reset()
        } else {
            let data = JSON.parse(JSON.stringify(this.data))
            console.log('data', data)
            this.uuid = data.uuid
            this.name = data.name
            this.idno = data.idno
            this.contact = data.contact
            this.dob = (data.dob == '' || data.dob == 'undefined') ? '' : data.dob
            this.myDate = (data.dob == '' || data.dob == 'undefined') ? '' : new Date(data.dob)
            this.career = data.career == 'UNDEFINED' ? '' : data.career
            this.address = data.address == 'UNDEFINED' ? '' : data.address
            this.remark = data.remark
            this.groupid = data.groupid
            this.status = data.status
            this.pictures = data.pictures
            this.initValues()
        }
    },
    methods: {
      checkFlag(pictures) {
            if (pictures && pictures !== '' && pictures.length > 0) {
                return true
            } else return false
        },
        checkImageUrl(pictures) {
            if (pictures && pictures !== '' && pictures.length > 0) {
                return pictures[0].url
            } else return false
        },
      delete_image(img_id) {
            let self = this
            var a = confirm('Delete this?')
            if (a) {
                this.$vs.loading()
                const baseURI = 'customer/pictures/' + this.pictures[0].id
                self.$http.delete(baseURI)
                    .then((result) => {
                        if (result.data.status == 'success') {
                            this.$vs.notify({
                                color: 'success',
                                title: 'Image Removed',
                                text: 'The selected attachment was successfully removed'
                            })
                            this.pictures = ''
                            this.$emit('updateParentImage')
                            this.$vs.loading.close()
                        }
                    })
            }
        },
        removeAllFiles() {
            this.$refs.myVueDropzone2.removeAllFiles();
        },
        sendingEvent(file, xhr, formData) {
            console.log(file, xhr, formData);
            formData.append("customer_uuid", this.uuid);
            formData.append("customer_picture", file);
        },
        afterComplete() {
            console.log('afterComplete')
            this.$refs.myVueDropzone2.removeAllFiles();
            this.$emit('updateParentImage')
            this.$emit('closeSidebar')
            this.initValues()
        },
        toggle() {
            this.flag_edit = true
            this.backup_contact_list = JSON.parse(JSON.stringify(this.contact_lists));
        },
        cancelEdit() {
            this.flag_edit = false
            this.contact_lists = JSON.parse(JSON.stringify(this.backup_contact_list));
        },
        new_contact() {
            this.contact_lists.push({
                address: '',
                contact_no: '',
                name: '',
                relationship: '',
                remark: ''
            })
        },
        showUpdateSuccess() {
            this.$vs.loading.close()
            this.$vs.notify({
                color: 'success',
                title: 'Dependent Updated',
                text: 'The selected customer dependent was successfully updated'
            })
            this.loadCustomerInfo(this.uuid)
        },
        remove_this(index) {
            this.contact_lists.splice(index, 1)
        },
        loadCustomerInfo(cus_id) {
            let self = this
            if (cus_id) {
                const baseURI = 'customers/' + cus_id

                self.$http.get(baseURI)
                    .then((result) => {
                        if (result.data.status == 'success') {
                            self.flag_edit = false
                            let customer_basic = result.data.data
                            console.log(customer_basic,'customer_basic')
                            if (customer_basic.dependents !== '') {
                                self.contact_lists = JSON.parse(customer_basic.dependents)
                            } else {
                                self.contact_lists = []
                            }
                        }
                    })
            }
        },

        fixDate(event) {
            return moment(event).format('YYYY-MM-DD');
        },
        initValues() {
            if (this.data.uuid) return
            this.uuid = ''
            this.name = ''
            this.idno = ''
            this.contact = ''
            this.dob = ''
            this.myDate = ''
            this.career = ''
            this.address = ''
            this.remark = ''
            this.groupid = this.user_info.group
            this.pictures = ''
            this.ori_pictures = ''
            // this.groupid = ''
            this.status = 'ACTIVE'
            this.contact_lists = []
        },
        submitData() {
            let self = this
            this.$validator.validateAll().then(result => {
                if (result) {

                    if (this.dob == 'UNDEFINED' || this.dob == 'undefined') {
                        this.dob = ''
                    }
                    if (this.address == 'UNDEFINED' || this.address == 'undefined') {
                        this.address = ''
                    }
                    if (this.career == 'UNDEFINED' || this.career == 'undefined') {
                        this.career = ''
                    }
                    if (this.remark == 'UNDEFINED' || this.remark == 'undefined') {
                        this.remark = ''
                    }

                    let formData = new FormData();

                    if (this.uuid !== '') {
                        formData.append('_method', 'PUT')
                    }
                    formData.append('name', self.name)
                    formData.append('idno', self.idno)
                    formData.append('dob', self.dob)
                    formData.append('contact', self.contact)
                    formData.append('address', self.address || '')
                    formData.append('career', self.career || '')
                    formData.append('remark', self.remark || '')
                    formData.append('groupid', self.groupid)
                    formData.append('status', self.status)

                    const obj = {
                        uuid: this.uuid,
                        name: this.name,
                        idno: this.idno,
                        dob: this.dob,
                        contact: this.contact,
                        address: this.address,
                        career: this.career,
                        remark: this.remark,
                        status: this.status,
                        groupid: this.groupid,

                        form_data: formData
                    }

                    console.log('before saved', obj)
                    // let temp = ''
                    this.$vs.loading()
                    if (this.uuid !== '') {
                        this.$store.dispatch("customerManagement/updateRecord", obj)
                            .then(() => {
                                // self.showUpdateSuccess()
                                // temp = this.uuid
                                if(self.contact_lists.length > 0){
                                  self.saveContact(this.uuid)
                                }
                                self.$vs.loading.close()
                                self.$emit('updateParentImage')
                                self.$emit('closeSidebar')
                            })
                            .catch(err => {
                                console.error(err)
                            })
                    } else {
                        this.$store.dispatch("customerManagement/addRecord", obj)
                            .then((data) => {
                                // Handle the case where customer ID might not be immediately available
                                let customerId = null;

                                // Try to get the customer ID from the response
                                if (data && data.data) {
                                    if (data.data.data && data.data.data.id) {
                                        customerId = data.data.data.id;
                                    } else if (data.data.data && data.data.data.uuid) {
                                        customerId = data.data.data.uuid;
                                    } else if (data.data.id) {
                                        customerId = data.data.id;
                                    } else if (data.data.uuid) {
                                        customerId = data.data.uuid;
                                    }
                                }

                                // If we have contacts to save and a customer ID
                                if (self.contact_lists.length > 0 && customerId) {
                                    self.saveContact(customerId);
                                } else if (self.contact_lists.length > 0) {
                                    // If no customer ID, show warning but still close
                                    self.$vs.notify({
                                        iconPack: "feather",
                                        icon: "icon-alert-triangle",
                                        color: "warning",
                                        title: "Customer Created",
                                        text: "Customer created but contacts could not be saved. Please edit the customer to add contacts."
                                    });
                                    self.$vs.loading.close();
                                    self.$emit("updateParentImage");
                                    self.$emit("closeSidebar");
                                } else {
                                    // No contacts to save, just close
                                    self.$vs.loading.close();
                                    self.$emit("updateParentImage");
                                    self.$emit("closeSidebar");
                                }
                            })
                            .catch(err => {
                                self.$vs.loading.close(); // Always close loading on error
                                self.$vs.notify({
                                    iconPack: "feather",
                                    icon: "icon-alert-circle",
                                    color: "danger",
                                    title: "Creation Failed",
                                    text: "Failed to create customer. Please try again."
                                });
                                console.error(err);
                            })
                    }
                }
            })
        },
        saveContact(uuid) {
            let self = this
            console.log('save contact', uuid, this.contact_lists)
            if (uuid && this.contact_lists.length > 0) {
                let formData = new FormData();

                formData.append('_method', 'PUT')
                formData.append('dependents', JSON.stringify(this.contact_lists))
                formData.append('uuid', uuid)

                const obj = {
                    uuid: uuid,
                    dependents: JSON.stringify(this.contact_lists),
                    form_data: formData
                }

                this.$vs.loading()
                this.$store.dispatch("customerManagement/updateContact", obj)
                    .then(() => {
                        this.dependentshowUpdateSuccess()
                    })
                    .catch(err => {
                        this.$vs.loading.close(); // Always close loading on error
                        this.$vs.notify({
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "danger",
                            title: "Contact Update Failed",
                            text: "Failed to update customer contacts. Please try again."
                        });
                        console.error(err);
                    })
            }
            setTimeout(() => {
                self.$emit('closeSidebar')
                self.initValues()
            }, 300);

        },
        dependentshowUpdateSuccess() {
            this.$vs.loading.close()
            this.$vs.notify({
                color: 'success',
                title: 'Dependent Updated',
                text: 'The selected customer dependent was successfully updated'
            })
            // this.loadCustomerInfo(this.customerId)
            this.$emit('closeSidebar')
            this.initValues()
        },
        // showUpdateSuccess() {
        //     this.$vs.loading.close()
        //     this.$vs.notify({
        //         color: 'success',
        //         title: 'Customer Updated',
        //         text: 'The selected customer was successfully updated'
        //     })
        // },
        showAddSuccess() {
            this.$vs.loading.close()
            this.$vs.notify({
                color: 'success',
                title: 'New Customer Added',
                text: 'New customer was successfully added'
            })
        },
        updateCurrImg(input) {
            if (input.target.files && input.target.files[0]) {
                const reader = new FileReader()
                reader.onload = e => {
                    this.dataImg = e.target.result
                }
                reader.readAsDataURL(input.target.files[0])
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
        z-index: 52010;
    }

    ::v-deep .vs-sidebar {
        z-index: 52010;
        width: 700px;
        max-width: 90vw;

        .img-upload {
            margin-top: 2rem;

            .con-img-upload {
                padding: 0;
            }

            .con-input-upload {
                width: 100%;
                margin: 0;
            }
        }
    }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
        overflow-y: auto;
    }
}
</style>
